export default __webpack_public_path__ + "ce717b851d3a49b7211c56b344b31778.png";